
<script>
import moment from 'moment'
import {
  calcDeltaPrice,
  formatPriceWithSign
} from '@/utils/helpers'
import TariffConditions from './TariffConditions.vue'
import PopupPenalties from '@/components/views/penalties/PopupPenalties.vue'
import dropdownIcon from '@/assets/images/icons/arrow-dropdown.svg?inline'
import sortIcon from '@/assets/images/icons/sort.svg?inline'

export default {
  name: 'accommodations',
  components: {
    TariffConditions,
    PopupPenalties,
    dropdownIcon,
    sortIcon
  },
  props: {
    hotelId: {
      type: Number,
      default: () => null
    },
    hotelIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    type: 'onlyCurrent',
    filtersChanged: false
  }),
  computed: {
    accommodations() {
      return this.$store.getters['cart/getHotelAccommodations'](this.hotelIndex)
    },
    mainServiceIsTours() {
      return this.$store.getters['cart/getMainService'] === 'tours'
    },
    hasAnotherAccommodation() {
      return this.accommodations.collection.length > 1
    },
    collection() {
      let result = []

      if (this.type === 'full') {
        result = this.accommodations.collection
      } else if (this.type === 'onlyCurrent') {
        result = [this.accommodations.current]
      }

      return result
    },
    collectionFilters() {
      return this.$store.getters['cart/getServiceField'](`hotels.${this.hotelIndex}.collectionFilters`)
    },
    isLoading() {
      return this.accommodations.isLoading
    },
    error() {
      return this.$store.getters['cart/getServiceModuleErrors'](`hotels.${this.hotelIndex}.accommodations`)
    },
    filters() {
      return this.$store.state.cart.hotels[this.hotelIndex].filters
    },
    mealsFilter: {
      get() {
        return this.$store.getters['cart/getServiceField'](`hotels.${this.hotelIndex}.filters.meals`)
      },
      set(value) {
        this.$store.commit('cart/updateServiceField', {
          target: `hotels.${this.hotelIndex}.filters.meals`,
          value
        })
      }
    },
    isNotPenalty: {
      get() {
        return this.$store.getters['cart/getServiceField'](`hotels.${this.hotelIndex}.form.isNotPenalty`)
      },
      set(value) {
        this.$store.commit('cart/updateServiceField', {
          target: `hotels.${this.hotelIndex}.form.isNotPenalty`,
          value
        })
      }
    },
    priceSort: {
      get() {
        return this.$store.getters['cart/getServiceField'](`hotels.${this.hotelIndex}.form.priceSort`)
      },
      set(value) {
        this.$store.commit('cart/updateServiceField', {
          target: `hotels.${this.hotelIndex}.form.priceSort`,
          value
        })
      }
    }
  },
  watch: {
    filters: {
      handler() {
        this.filtersChanged = true
      },
      deep: true
    },
    isNotPenalty: {
      handler() {
        this.processAccommodationsList()
      }
    },
    priceSort: {
      handler() {
        this.processAccommodationsList()
      }
    }
  },
  methods: {
    processAccommodationsList() {
      this.$store.commit('cart/updateServiceModuleIsLoading', {
        status: true,
        target: `hotels.${this.hotelIndex}.accommodations`
      })

      if (this.mainServiceIsTours) {
        const hotelForm = this.$store.getters['cart/getHotelForm'](this.hotelIndex)
        const startDate = moment.unix(this.accommodations.current.startDate).format('DD.MM.YYYY')

        this.$store.dispatch('cart/getTourAccommodations', {
          hotelIndex: this.hotelIndex,
          params: {
            ...this.$store.getters['cart/getTourForm'],
            currency: this.$store.getters['cart/getCartPrice'].currency,
            rooms: hotelForm.rooms,
            startDate,
            endDate: moment(startDate, 'DD.MM.YYYY')
              .add(this.accommodations.current.duration, 'days')
              .format('DD.MM.YYYY'),
            priceSort: hotelForm.priceSort,
            filters: hotelForm.filters
          }
        })
      } else {
        this.$store.dispatch('cart/getHotelAccommodations', {
          hotelId: this.hotelId,
          hotelIndex: this.hotelIndex,
          form: {
            ...this.$store.getters['cart/getHotelForm'](this.hotelIndex)
          }
        })
      }
    },
    isCurrentActive(id) {
      return id === this.accommodations.current.id
    },
    formatPrice(price) {
      const slug = this.$store.getters['cart/getCartPrice'].currency
      const dictionary = this.$store.getters.getDictionary('cart.dictionaries.currencies')

      return formatPriceWithSign(price, slug, dictionary)
    },
    calcDeltaPrice(price) {
      return calcDeltaPrice(this.accommodations.current.price.amount, price)
    },
    async select(hotelId, accommodationId) {
      this.$store.commit('cart/selectAccommodation', {
        hotelIndex: this.hotelIndex,
        accommodationId
      })

      if (this.mainServiceIsTours) {
        await this.updateTransfers()
      }

      this.$store.dispatch('cart/getActualize')

      if (accommodationId) {
        this.$store.dispatch('cart/getServicePenaltiesForAll', {
          ids: {
            accommodationSearchId: this.$store.getters['cart/getIds'].hotels[this.hotelIndex].accommodationSearchId,
            hotelId: this.$store.getters['cart/getIds'].hotels[this.hotelIndex].id,
            accommodationId: this.$store.getters['cart/getIds'].hotels[this.hotelIndex].accommodationId,
            currency: this.$store.getters['cart/getCartPrice'].currency
          },
          serviceName: 'hotels',
          serviceId: hotelId,
          apiModuleName: 'cart',
          label: 'Отель'
        })
      } else {
        this.$store.commit('cart/removeServiceFromAllPenalties', {
          service: 'hotels',
          serviceId: hotelId
        })
      }
    },
    async updateTransfers() {
      const hotels = this.$store.getters['cart/getIds'].hotels
        .map(hotel => hotel.accommodationId)
      const flights = this.$store.getters['cart/getIds'].flights
        .map(flight => flight.recommendationId)
      const transfers = this.$store.getters['cart/getIds'].transfers
        .map(transfer => transfer.vehicleId)

      await this.$store.dispatch('cart/getTourTransfers', {
        hotels,
        flights,
        transfers,
        currency: this.$store.getters['cart/getCartPrice'].currency,
        tourTemplateId: this.$store.getters['cart/getTourForm'].tourTemplateId
      })
    },
    changeRenderFormat(type) {
      this.type = type
    },
    changeSortType() {
      this.priceSort = this.priceSort === 'ascending'
        ? 'descending'
        : 'ascending'
    },
    showForm() {
      this.$parent.formIsShown = true
    },
    handleDropdownStateChange(isActive) {
      if (!isActive && this.filtersChanged) {
        this.processAccommodationsList()
        this.filtersChanged = false
      }
    }
  }
}
</script>

<template>
  <div class="cart__hotel-accommodations">
    <b-loading
      v-if="isLoading"
      :is-full-page="false"
      :active="isLoading"
    />
    <div
      v-if="!isLoading"
      class="cart__hotel-accommodations-content"
    >
      <div
        v-if="error.hasError"
      >
        <h2
          v-for="(item, index) in error.errorsList"
          :key="index"
          class="cart__hotel-accommodations-error"
        >
          {{ item }}
        </h2>
      </div>
      <div
        v-if="error.hasError"
        class="cart__hotel-accommodations-control"
      >
        <a
          href="javascript:;"
          class="rex-btn"
          @click="showForm"
        >
          <span>Изменить</span>
        </a>
      </div>
      <b-table
        v-if="!error.hasError"
        :data="collection"
        :row-class="(row, index) => 'cart__table-item'"
        class="cart__hotel-accommodations-table cart__table"
      >
        <template slot-scope="accommodation">
          <b-table-column
            label="Номер"
            :width="340"
          >
            <p
              v-for="(item, index) in accommodation.row.room"
              :key="index"
            >
              {{ item.type }}
            </p>
          </b-table-column>
          <b-table-column
            label="Жильцы"
            :width="100"
          >
            <p
              v-for="(item, index) in accommodation.row.tourists"
              :key="index"
            >
              {{ item }}
            </p>
          </b-table-column>
          <b-table-column
            :width="170"
            label="Питание"
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <template v-if="type === 'onlyCurrent' || collectionFilters.meals.length === 1">
                {{ column.label }}
              </template>
              <b-dropdown
                v-else
                v-model="mealsFilter"
                aria-role="list"
                multiple
                @active-change="handleDropdownStateChange"
              >
                <template slot="trigger">
                  <a
                    href="javascript:;"
                    class="cart__hotel-accommodations-table-button"
                    :class="{ active: mealsFilter.length }"
                  >
                    {{ column.label }}
                    <dropdownIcon />
                  </a>
                </template>
                <b-dropdown-item
                  aria-role="listitem"
                  :class="{'is-active': !mealsFilter.length}"
                  @click="mealsFilter = []"
                >
                  Все
                </b-dropdown-item>
                <b-dropdown-item
                  v-for="(item, index) in collectionFilters.meals"
                  :key="index"
                  :value="item.slug"
                  aria-role="listitem"
                >
                  {{ item.name }}
                </b-dropdown-item>
              </b-dropdown>
            </template>
            <p>{{ accommodation.row.meals.mapped }}</p>
          </b-table-column>
          <b-table-column
            :width="100"
            label="Цена"
          >
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <template v-if="type === 'onlyCurrent'">
                {{ column.label }}
              </template>
              <a
                v-else
                href="javascript:;"
                class="
                  cart__hotel-accommodations-table-button
                  cart__hotel-accommodations-table-button--sort
                "
                :class="{
                  'cart__hotel-accommodations-table-button--sort-desc': priceSort === 'descending',
                }"
                @click="changeSortType"
              >
                <sort-icon
                  class="cart__hotel-accommodations-table-button-icon-sort"
                />
                {{ column.label }}
              </a>
            </template>
            <p>
              <b>
                {{ formatPrice(accommodation.row.price.amount) }}
              </b>
            </p>
          </b-table-column>
          <b-table-column
            :width="50"
            label="Тариф"
          >
            <template
              v-if="!mainServiceIsTours"
              slot="header"
              slot-scope="{ column }"
            >
              <template v-if="type === 'onlyCurrent'">
                {{ column.label }}
              </template>
              <b-dropdown
                v-else
                v-model="isNotPenalty"
                aria-role="list"
                @active-change="handleDropdownStateChange"
              >
                <template slot="trigger">
                  <a
                    href="javascript:;"
                    class="cart__hotel-accommodations-table-button"
                    :class="{ active: isNotPenalty !== 0 }"
                  >
                    {{ column.label }}
                    <dropdown-icon />
                  </a>
                </template>
                <b-dropdown-item
                  :value="0"
                  aria-role="listitem"
                  :class="{ active: isNotPenalty === 0 }"
                >
                  Все
                </b-dropdown-item>
                <b-dropdown-item
                  value="1"
                  aria-role="listitem"
                >
                  С бесплатной отменой
                </b-dropdown-item>
              </b-dropdown>
            </template>
            <div class="cart__table--center">
              <popup-penalties
                :ids="{
                  hotelId,
                  accommodationSearchId: accommodations.searchId,
                  accommodationId: accommodation.row.id
                }"
                store-module="cart"
                service-name="hotels"
                :target="`hotels.${hotelIndex}`"
                api-module-name="cart"
              />
              <tariff-conditions
                :ids="{
                  hotelId,
                  accommodationSearchId: accommodations.searchId,
                  accommodationId: accommodation.row.id
                }"
                :meal="accommodation.row.meals.supplier"
                :room="accommodation.row.room"
                :hotel-index="hotelIndex"
              />
            </div>
          </b-table-column>
          <b-table-column
            :width="90"
            class="cart__hotel-accommodations-table-select-button"
          >
            <b-button
              class="rex-button2"
              type="is-primary"
              expanded
              :outlined="!isCurrentActive(accommodation.row.id)"
              @click="select(hotelId, accommodation.row.id)"
            >
              {{
                isCurrentActive(accommodation.row.id)
                  ? 'Выбрано'
                  : 'Выбрать'
              }}
            </b-button>
          </b-table-column>
        </template>
      </b-table>
      <div
        v-if="!error.hasError && hasAnotherAccommodation"
        class="cart__hotel-accommodations-control"
      >
        <b-button
          v-if="type === 'full'"
          type="is-light"
          class="rex-button2"
          @click="changeRenderFormat('onlyCurrent')"
        >
          Свернуть все
        </b-button>
        <a
          v-if="type === 'onlyCurrent'"
          href="javascript:;"
          class="
            rex-btn
            cart__hotel-accommodations-btn
            cart__hotel-accommodations-btn--blackout
          "
          @click="changeRenderFormat('full')"
        >
          <span>Показать все</span>
        </a>
      </div>
    </div>
  </div>
</template>